<template>
    <footer>
        <div class="mt-10 mb-5">
            <hr class="my-10 border-line-color">

            <div class="text-2xl w-1/2 mx-auto md:w-1/5 flex justify-between text-medium-grey">
                <a target="_blank" href="https://github.com/freeborn-coder"><i class="fab fa-github"></i></a>
                <a href="https://linkedin.com/in/freeborn-iwarri" target="_blank" rel="noopener noreferrer"><i class="fab fa-linkedin"></i></a>
                <a target="_blank" href="https://facebook.com/freeeborni"><i class="fab fa-facebook"></i></a>
                <!-- <a href="https://twitter.com/" target="_blank" rel="noopener noreferrer"><i class="fab fa-twitter"></i></a> -->
            </div>
        </div>
    </footer>
</template>

<script>
    export default {
        
    }
</script>

<style scoped>

</style>
